import { render, staticRenderFns } from "./AddStorageLocationDialog.vue?vue&type=template&id=71f787d4&scoped=true&lang=pug&"
import script from "./AddStorageLocationDialog.vue?vue&type=script&lang=js&"
export * from "./AddStorageLocationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f787d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VForm,VIcon})
